<template>
	<div class="menu-group" v-if="filterMenuFromGroup.length != 0">
		<h3
			class="menu-group-topic text-heading3--bold" 
			:id="(page_form == 'searchPage') ? 'cate-search-head-'+category.name :'category-head-'+category.name">
			{{ category.name }}
		</h3>
		<MenuItem 
			:id="'item-menu-' + menu.id" 
			v-for="(menu, index) in filterMenuFromGroup" :class="index != filterMenuFromGroup.length - 1 && 'menu-border-bottom'" 
			:key="index" 
			:menu="menu" 
			@click.native="routeToMenuDetail(menu)"
		/>
		<div class="category-bottom-bar" :id="'category-bottom-'+category.name"></div>
	</div>
</template>
<script>
import MenuItem from './MenuItem'
import Mixins from '@/utils/mixins'

export default {
	name: 'MenuGroup',
	mixins: [Mixins],
	components: {
		MenuItem
	},
	props: {
		category: {
			default: {}
		},
		menu_data: {
			default: []
		},
		page_form: {
			default: 'menuPage'
		},
		restaurant_uuid: {
			default: ''
		},
		branch_uuid: {
			default: ''
		},
		groupindex: {
			default: 0
		}
	},
	mounted () {
		let text_menu_uuid = `item-menu-${this.MenuUUID}`
		let ele_menu_uuid = document.getElementById(text_menu_uuid)
		if (ele_menu_uuid == null) {
			window.scrollTo(0,0)
		} else {
			ele_menu_uuid.scrollIntoView({ block: 'center' })
		}
	},
	methods: {
		routeToMenuDetail (menu) {
			const { restaurant_uuid = '',  branch_uuid = '' } = this.$route.params
			this.$router.push({ 
				name: 'MenuDetail',
				params: { 
					restaurant_uuid, 
					branch_uuid,
					menu_uuid: menu.id, 
					menu
				},
				query: { action: 'addCart' }
			})
		}
	},
	computed: {
		filterMenuFromGroup () {
			return this.menu_data.filter(item => !item.isSoldOut)
		},
		MenuUUID () {
			return this.$store.getters.MenuUUID
		}
	},
	watch: {
		MenuUUID () {}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/menu/MenuGroup.vue